module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/cd77be4ebde61bded8556897c1f7e11f.png";